
import Signal from './signal'
import TrackCompany from './tracker/track-company.vue'
import TrackPerson from './tracker/track-person.vue'
import TrackTopic from './tracker/track-topic.vue'
import EditTopic from './tracker/edit-topic.vue'
import EditPerson from './tracker/edit-person.vue'
import EditCompany from './tracker/edit-company.vue'
import TrackCompanies from './tracker/track-companies.vue'

export default {
  components: {EditTopic, Signal, TrackTopic, TrackPerson, EditCompany, TrackCompany, TrackCompanies, EditPerson},
  props: {
    view: {type: String, default: undefined, validator: v => ['signal', 'edit-company', 'edit-person', 'edit-topic', 'track-company', 'track-person', 'track-companies', 'track-topic'].includes(v)},
    data: {type: Object, default: undefined}
  },
  emits: ['close'],
  computed: {
    c_key(){
      return JSON.stringify(this.data)
    },
  },
  methods: {
    close(){
      this.$emit('close')
    }
  }
}
